module.exports = __webpack_public_path__ + "img/rebot_3.ed921995.png";